import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lh-empty',
  template: '',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class EmptyComponent {}
